import { useEffect, useState } from "react"
import BotzappingForm from "../components/BotzappingForm"
import InstallTrackingCode from "../components/InstallTrackingCode"
import Whitelist from "../components/Whitlisting"
import FormService from "../services/formService"
import tracker from "../services/tracker"

const initialSettingsState = {
  whitelist: [],
  maxWhitelistLength: 0
}

const InstallationForm = () => {
  const { getSettings } = new FormService()
  const [initSettings, setInitSettings] = useState(initialSettingsState)

  useEffect(() => {
    async function setSettings() {
      const res = await getSettings()
      if(res?.data){
        tracker.init(res.data.clientId)
        setInitSettings(res?.data?.data)
      }
    }
    setSettings()
    // eslint-disable-next-line
  }, [])

  return (
    <div className="content">
      <BotzappingForm initSettings={initSettings}/>
      <Whitelist list={initSettings.whitelist} maxLength={initSettings.maxWhitelistLength}/>
      <InstallTrackingCode initSettings={initSettings}/>
    </div>
  )
}

export default InstallationForm
